import classNames from "classnames"
import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import BlockHeader from "@/common/partials/block-header/block-header"
import styles from "./faq.module.css"

export default function FAQ({ block }) {
  const { attrs, innerBlocks } = block
  const { bgColor, blockGap, heading, text } = attrs

  if (innerBlocks.length === 0) {
    return null
  }

  return (
    <Block
      block={block}
      width="bleed"
      gap={blockGap ?? "normal"}
      className={classNames(styles.wrapper, "bg-color-" + bgColor)}>
      <div className="columns">
        <BlockHeader
          align="left"
          heading={heading}
          text={text}
          className="block-header"
        />
        <Blocks
          blocks={innerBlocks}
          settings={{
            "theme/accordion": { blockGap: "none", isFaq: true }
          }}
        />
      </div>
    </Block>
  )
}
